<template>
  <ul>
    <li v-for="item in obj" :key="item.title" class="animate__animated animate__fadeInUp">
      <img :src="$baseURL + item.thumb" :alt="item.title" />
      <div class="text">
        <h3>{{ item.title }}</h3>
        <p class="dh_text3">
          {{ item.description }}
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
import image from "@/assets/image/solution_td.png";

export default {
  props: {
    obj: {
      type: Array,
    },
  },
  data() {
    return {
      image,
    };
  },
};
</script>

<style lang="less" scoped>
ul {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 40px;

  li {
    position: relative;
    text-align: center;
    position: relative;

    img {
      width: 100%;
    }

    .text {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      color: #fff;
      overflow: hidden;
      border-radius: 15px;
      background: linear-gradient(to bottom, #00000044 50%, var(--themeColor));
      transition: all 0.3s;

      h3 {
        font-weight: bold;
        font-size: 20px;
        margin-bottom: 30px;
        transition: all 0.3s;
        position: relative;
        top: 70%;

        &::after {
          content: "";
          width: 2em;
          height: 2px;
          background: #fff;
          position: absolute;
          bottom: -15px;
          left: 50%;
          transform: translateX(-50%);
        }
      }

      p {
        width: 66%;
        margin: auto;
        font-size: 16px;
        line-height: 2;
        transition: all 0.3s;
        position: relative;
        top: 75%;
        opacity: 0;
      }

      @media (min-width: 900px) {
        &:hover {
          h3 {
            top: 30%;
          }

          p {
            top: 30%;
            opacity: 1;
          }
        }
      }
    }
  }
}

@media (max-width: 900px) {
  ul {
    grid-gap: 20px;
  }
}

@media (max-width: 850px) {
  ul {
    grid-template-columns: repeat(2, 1fr);

    li {
      .text {
        h3 {
          top: 30%;
        }

        p {
          top: 30%;
          opacity: 1;
        }
      }
    }
  }
}

@media (max-width: 550px) {
  ul {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>